export const API_PORT = process.env.VUE_APP_API_PORT || '3000'
export const API_URL = 'http://195.24.66.128'// process.env.VUE_APP_API_URL || `http://localhost:${API_PORT}`
export const DOMAIN_TITLE = process.env.VUE_APP_DOMAIN_TITLE || 'valet.airparking24.ru'